import React, { useEffect, useMemo } from 'react';
import { List } from 'antd';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { fetchCommentsByProduct } from '../../services';
import CommentComposer from './CommentComposer';
import CommentNode from './CommentNode';
import { CommentNodeType } from '../interfaces';
import { normalizeCommentTree } from './commentTree';
import './commentSection.scss';

const CommentSection = () => {
    const dispatch = useAppDispatch();
    const userId = useAppSelector(state => state.user.user?.id);
    const comments = useAppSelector(state => state.comment.comments);
    const productId = useAppSelector(state => state.curProduct.productId?.id);

    useEffect(() => {
        if (productId) {
            dispatch(fetchCommentsByProduct({ productId }));
        }
    }, [dispatch, productId]);

    const commentItems = useMemo(
        () => (comments || []).flatMap(comment => comment.commentItems || []),
        [comments]
    );
    const commentTree = useMemo(() => normalizeCommentTree(commentItems), [commentItems]);

    return (
        <div className="comment-section">
            <h3>Comments</h3>
            {userId && productId && (
                <CommentComposer
                    userId={userId}
                    productId={productId}
                    buttonLabel="Add Comment"
                    placeholder="Add a comment..."
                />
            )}
            <List
                dataSource={commentTree}
                renderItem={(item: CommentNodeType) => (
                    <List.Item key={item.id} className="comment-list-row">
                        <CommentNode item={item} userId={userId} productId={productId} />
                    </List.Item>
                )}
                style={{ marginTop: '20px' }}
            />
        </div>
    );
};

export default CommentSection;
